import { ICartItem } from '../interfaces/ICartItem';

export const calcOrderPrice = (item: ICartItem): number => {
  let baseProductsPrice = 0;
  let sumComponentsPrices = 0;

  if (item.childOrderItems.length || item.gridProduct) {
    if (item.compositeProduct.product.controlGrid === 2) {
      baseProductsPrice =
        item.childOrderItems
          .map((pizza) =>
            pizza.produto.grids[0]?.discount &&
            pizza.produto.grids[0].discount.active
              ? +pizza.produto.grids[0].price.value * +pizza.quantidade -
                +pizza.produto.grids[0].discount.price * +pizza.quantidade
              : +pizza.produto.grids[0].price.value * +pizza.quantidade,
          )
          .reduce((total, next) => total + next) * item.quantity;
    } else if (item.gridProduct) {
      baseProductsPrice =
        item.gridProduct?.discount && item.gridProduct.discount.active
          ? +item.gridProduct.price.value * +item.quantity -
            +item.gridProduct.discount.price * +item.quantity
          : +item.gridProduct.price.value * +item.quantity;
    }
  } else {
    baseProductsPrice =
      item.compositeProduct.product?.discount &&
      item.compositeProduct.product.discount.active
        ? +item.compositeProduct.product.price.value * +item.quantity -
          +item.compositeProduct.product.discount.price * +item.quantity
        : +item.compositeProduct.product.price.value * +item.quantity;
  }

  if (item.compositeProduct.complements.length) {
    sumComponentsPrices = item.compositeProduct.complements
      .map(
        (complemento) =>
          +complemento.complement.price.value *
          +complemento.quantity *
          +item.quantity,
      )
      .reduce((total, next) => +total + +next);
  }
  return Number((baseProductsPrice + sumComponentsPrices).toFixed(2));
};
